import { useSelector, useDispatch } from 'react-redux';
import { useRef, useMemo, useEffect } from 'react';
import { currentSelectedLanguage, setSearchedUserName } from '../../../../StateManagement/actions';
import useFetchSettings from '../hooks/useFetchSettings';
export default function SearchBar({ onSearch, onReset,onSearchInputChange,collapseAside, populateCompany }) {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    const settingFor = useSelector((state) => state.settings.settingFor);
    const searchRef = useRef('');
    const CompanyNameSearch = useRef('');
    const searchInputTimeout = useRef(null);
    const dispatch = useDispatch();
    const userRole = useMemo(() => localStorage.getItem('UserRole'), []);

    const {getActiveTabSettings}=useFetchSettings();
    
    const onSearchHandler = () => {
        onSearch(searchRef.current.value, CompanyNameSearch.current.value);
    }
    
    const onResetHandler = () => {
        if (searchRef.current) searchRef.current.value = '';
        if (CompanyNameSearch.current) CompanyNameSearch.current.value = '';
        onReset();
    }
    
    const handleSearchInput = (e, isCompanySearch = false) => {
        const searchText = isCompanySearch ? searchRef.current?.value || '' : e.target.value;
        const companyName = isCompanySearch ? e.target.value : CompanyNameSearch.current?.value || '';
        
        if (searchInputTimeout.current) {
            clearTimeout(searchInputTimeout.current);
        }
        searchInputTimeout.current = setTimeout(() => {
            dispatch(setSearchedUserName({
                searchText,
                companyName
            }));
            //onSearchInputChange(false);
        }, 300);
    }
    
    useEffect(() => {
        return () => {
            if (searchInputTimeout.current) {
                clearTimeout(searchInputTimeout.current);
            }
        };
    }, []);

   useEffect(() => {
    if(userRole === "RDocsSupportAdmin" && settingFor==="Company" && populateCompany.companyName!==""){
        if(populateCompany && CompanyNameSearch.current){
            CompanyNameSearch.current.value=populateCompany.companyName;
            onSearch("",populateCompany.companyName,"General");
        }
    }
   }, [populateCompany]);
   

    return (
        <>
            <div className={`search-heading ${collapseAside} `}>
                <div className="row align-items-center px-3 mb-4 py-3 bg-white">
                    {userRole === "RDocsCustomerAdmin" && (
                        <>
                            <div className="col-sm-2">
                                <label
                                    htmlFor="userMailId"
                                    className="col-form-label font-w600 control res-w">
                                    {selectedLanguage.LstLanguageCodes.UI_SearchUser}
                                </label>
                            </div>
                            <div className="col-sm-9 ps-1 d-flex align-items-center">
                                <input
                                    name="userMailId"
                                    autoComplete="off"
                                    id="userMailId"
                                    className="form-control red-shadow border-r4"
                                    type="text"
                                    aria-label="Search"
                                    ref={searchRef}
                                    onChange={(e) => handleSearchInput(e, false)}
                                    title={selectedLanguage.LstLanguageCodes.UI_SearchUserPlaceHolderContent} 
                                    placeholder={selectedLanguage.LstLanguageCodes.UI_SearchUserPlaceHolderContent}

                                />
                                <button
                                    className="btn btn-primary mx-3 serchicon"
                                    type="submit" onClick={onSearchHandler}>
                                    <span className="material-icons top3px">search</span>
                                </button>
                                <button className="btn btn-danger reseticon" type="reset" onClick={onResetHandler}>
                                    <span
                                        className="material-icons top3px"
                                        style={{ fontSize: "23px" }}>
                                        not_interested
                                    </span>
                                </button>
                            </div>
                        </>
                    )}
                    {userRole === "RDocsSupportAdmin" && (
                        <>
                            <div className="col-sm-4 ps-1 d-flex align-items-center">
                                <input
                                    name="CompanyName"
                                    autoComplete="off"
                                    id="CompanyName"
                                    className="form-control red-shadow border-r4"
                                    type="text"
                                    ref={CompanyNameSearch}                                   
                                    placeholder={
                                        selectedLanguage.LstLanguageCodes
                                            .UI_EnterCompanyName
                                    }
                                    aria-label="Search"
                                    onChange={(e) => handleSearchInput(e, true)}

                                />
                            </div>
                            <div className="col-sm-4 ps-1 d-flex align-items-center">
                                <input
                                    name="userMailId"
                                    autoComplete="off"
                                    id="userMailId"
                                    className="form-control red-shadow border-r4"
                                    type="text"
                                    ref={searchRef}
                                    placeholder={
                                        selectedLanguage.LstLanguageCodes
                                            .UI_EnterEmailAddress
                                    }
                                    aria-label="Search"
                                    onChange={(e) => handleSearchInput(e, false)}

                                />
                            </div>
                            <div className="col-sm-4 ps-1 d-flex align-items-center">
                                <button
                                    className="btn btn-primary mx-3 serchicon"
                                    type="submit" onClick={onSearchHandler}>
                                    <span className="material-icons top3px">
                                        search
                                    </span>
                                </button>
                                <button
                                    className="btn btn-danger reseticon"
                                    type="reset" onClick={onResetHandler}>
                                    <span
                                        className="material-icons top3px"
                                        style={{ fontSize: "23px" }}>
                                        not_interested
                                    </span>
                                </button>
                            </div>
                        </>
                    )}

                </div>
            </div>

        </>
    )
}


